// extracted by mini-css-extract-plugin
export default {"imgContain":"FN","content":"GN","titleAndImage":"HN","title":"IN","text":"JN","rhodeTitle":"KN","shortHR":"LN","modal_root":"MN","x_mark":"NN","flavorStickModal":"ON","greenBox":"PN"};
    if(module.hot) {
      // 1743628927685
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  